export default __webpack_public_path__ + "static/gradient-ed7e8ea83472dc4f9da8b668af775eed.png";